// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__uJIex","left":"style__left__ag2Hw","right":"style__right__vC5IS","itemContainer":"style__itemContainer__IHGR+","colorBox":"style__colorBox__q6g+r"};